@if(statusCount(); as statusCount) {
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Status</th>
		<th>English</th>
		<th>Spanish</th>
	</tr>
	@for(map of statusCount; track map.status) {
	<tr>
		<td>{{map.status}}</td>
		<td>{{map.english}}</td>
		<td>{{map.spanish}}</td>
	</tr>
	}
</table>
}